import { parseTargetToRequest } from 'helpers/target';
import {
  CAMPAIGN_TITLE,
  CountryCaUs,
  dateTimeDefault,
  DEFAULT_OFFSET_FOR_MONITORING,
  DefaultMainAudioTag,
  FilterTargetTypeEnum,
  MainAudioTag,
  ModesResponderEnum,
  optionFilterHistory,
  SanitizingTypeEnum,
  sendMethodEnum,
  stateCampaign,
  stateOffer,
  stateVoluumMapping,
} from 'consts/data';
import {
  isArray,
  isString,
  isObject,
  cloneDeep,
  get,
  sortBy as sortByLodash,
  isEmpty,
  isPlainObject,
  isBoolean,
} from 'lodash';
import moment from 'moment';
import { messageType as messageTypeEnum } from 'consts/data';
import {
  calculateTimeRemainingCampaign,
  convertDurationStats,
  momentInstance,
  newDate,
  parseDateRangesForFilters,
  setTimeOfDateToDefault,
} from 'helpers/date-time';
import { calculateIVR, costCalculator, statsCalculator } from 'helpers/calculate';
import { fixedValue } from 'helpers/form';
import { checkTypeOffer } from 'helpers/offer';
import {
  checkSwitchQRAndAttachment,
  cloneObjectByKeys,
  convertToFormSelect,
  getQueryStringFromURL,
  isDefine,
  isDefineValueOr,
  isNumeric,
  numberToPercentage,
  removeKeyFromObj,
} from 'helpers';
import { convertValueStringToNumberToCompare, localeNumber } from 'helpers/string';
import MediaModel from './media.model';
import {
  parseAutoOptimization,
  parseResponderOffer,
  parseOffers,
  parseCreatives,
  parseRoutes,
  parsePopulateGroup,
  parseANIS,
  collectRawStats,
  parseStatsToCalculate,
  initialResponderOffers,
  parseResponderForwardPhones,
  parseSuppressionContactGroup,
  parseResponderOnfly,
  parseResponderAndTemplate,
  parseTrackingVendor,
  parseMedia,
  parseOptoutLink,
  parseSanitizingUnicode,
  parseEvaluatedElements,
  parseDTMFTimeoutAndAMD,
  parseDebugMode,
  parseAIAgent,
} from 'helpers/parseBodyForSendCampaign';
import CacheService from 'services/CacheService';
import ResponderV2Model from './responder-v2.model';
import OptOutModel from './optout.model';
import { timezoneHelpers } from 'providers/TimezoneProvider';
import { DEFAULT_DATETIME_MONITORING_FORMAT } from 'consts/dateFormats';

export class CampaignStatModel {
  constructor(values) {
    this.delivered = values?.delivered;
    this.failed = values?.failed;
    this.attemptFailed = values?.attemptFailed;
    this.blocked = values?.blocked;
    this.replied = values?.replied;
    this.listened = values?.listened;
    this.optout = values?.optout;
    this.carrierName = values?.carrierName;
    this.revenue = values?.revenue;
    this.received = values?.received;
    this.callback = values?.callback;
    this.timestamp = values?.timestamp;
    this.from = values?.from;
    this.to = values?.to;
    this.callDurationInSecond = values?.callDurationInSecond;
    this.callDurationInMinute = values?.callDurationInMinute;
    this.callDuration = values?.callDuration;

    this.datetime = values?.datetime;
    this.sent = values?.sent;
    this.clicked = values?.clicked;
    this.convertor = values?.convertor;
    this.cost = values?.cost;
    this.revenue = values?.revenue;
  }
}

const allMsgTypeSupportVoice = [
  messageTypeEnum.mms,
  messageTypeEnum.mmse,
  messageTypeEnum.voice,
  messageTypeEnum.ringlessVoicemail,
  messageTypeEnum.RVM,
];
class CampaignModel {
  static templateRoute = {
    routeId: '',
    didGroupIds: [],
    countryOfContact: '',
    is10dlc: undefined,
  };

  static initialCampaignCompose(historyResend, { defaultMessageType, timeName, settings }) {
    console.log('historyResend', historyResend);
    return {
      agent: !!historyResend?.setting?.agent,
      debug: !!historyResend?.setting?.debug,
      amdEventEnabled: !!historyResend?.setting?.amdEventEnabled,
      dtmfTimeout:
        historyResend?.setting?.dtmfTimeout > -1 ? historyResend?.setting?.dtmfTimeout : undefined,

      certedVertical: historyResend?.setting?.certedVertical || false,
      qrEnabled: historyResend?.qrEnabled || false,
      urlShortenerSettings: false,
      urlShortened: historyResend?.urlShortened || false,
      messageType: historyResend?.messageType || defaultMessageType,
      areaCode: '',
      fromPhone: '',
      audioId: '',
      phone: '',

      sendMethod: historyResend?.sendMethod || sendMethodEnum.twoWays,
      ani: historyResend?.ani || '',
      routeId: '',
      didGroupId: '',

      creativeIds: historyResend?.creativeIds || [],
      creativeOnFly: [],

      offerIds: historyResend?.offerIds || [],
      offerOnFly: [],
      offerOption: historyResend?.offerOption || stateOffer.OFFER,
      domain: historyResend?.domain || '',

      impressionUrl: historyResend?.conversionUrl || '',
      verifyUrl: false,

      //* Advance Setting
      minDate: historyResend?.startTime ? new Date(historyResend?.startTime) : undefined,
      scheduling: historyResend?.startTime ? new Date(historyResend?.startTime) : undefined,
      schedulingStopTime: historyResend?.stopTime ? new Date(historyResend?.stopTime) : undefined,

      timeName: historyResend?.timeName || timeName,
      activeScheduling: historyResend?.activeScheduling || false,
      sendByContactTimezone: historyResend?.sendByContactTimezone || false,

      // Voluum
      voluumMapping: stateVoluumMapping.NO_MAPPING,
      voluumSetting: {
        uuid: '',
        campaignName: '',
      },

      //* Optimization
      autoOptimization: {
        autoOp: historyResend?.setting?.autoOptimization.autoOp ?? settings?.autoOpActive ?? false,
        testSize:
          historyResend?.setting?.autoOptimization.testSize ?? settings?.autoOpTestSizeLap1 ?? '',
        pausedMin:
          historyResend?.setting?.autoOptimization.pausedMin ?? settings?.autoOpPausedMinLap1 ?? '',
        threshold:
          historyResend?.setting?.autoOptimization.threshold ?? settings?.autoOpThresholdLap1 ?? '',
        thresholdPerReply:
          historyResend?.setting?.autoOptimization.thresholdPerReply ??
          settings?.autoOpThresholdPerReplyLap1 ??
          '',
        thresholdPerBlock:
          historyResend?.setting?.autoOptimization.thresholdPerBlock ??
          settings?.autoOpThresholdPerBlockLap1 ??
          '',
        thresholdPerOptout:
          historyResend?.setting?.autoOptimization.thresholdPerOptout ??
          settings?.autoOpThresholdPerOptoutLap1 ??
          '',
        thresholdPerConvertor:
          historyResend?.setting?.autoOptimization.thresholdPerConvertor ??
          settings?.autoOpThresholdPerConvertorLap1 ??
          '',

        thresholdRevenuePerMilMessage:
          historyResend?.setting?.autoOptimization.thresholdRevenuePerMilMessage ??
          settings?.autoOpThresholdRevenuePerMilMessage ??
          '',
        thresholdRevenuePerMilMinute:
          historyResend?.setting?.autoOptimization.thresholdRevenuePerMilMinute ??
          settings?.autoOpThresholdRevenuePerMilMinute ??
          '',
        thresholdRevenuePerDeliveredCall:
          historyResend?.setting?.autoOptimization.thresholdRevenuePerDeliveredCall ??
          settings?.autoOpThresholdRevenuePerDeliveredCall ??
          '',
        thresholdCallRate:
          historyResend?.setting?.autoOptimization.thresholdCallRate ??
          settings?.autoOpThresholdCallRate ??
          '',
        thresholdRoi:
          historyResend?.setting?.autoOptimization.thresholdRoi ??
          settings?.autoOpThresholdRoi ??
          '',

        // Lap2
        autoOpLap2CreativeSize:
          historyResend?.setting?.autoOptimization.autoOpLap2CreativeSize ??
          settings?.autoOpLap2CreativeSize ??
          '',

        autoOpLap2:
          historyResend?.setting?.autoOptimization.autoOpLap2 ??
          settings?.autoOpLap2Active ??
          false,
        testSizeLap2:
          historyResend?.setting?.autoOptimization.testSizeLap2 ??
          settings?.autoOpTestSizeLap2 ??
          '',
        pausedMinLap2:
          historyResend?.setting?.autoOptimization.pausedMinLap2 ??
          settings?.autoOpPausedMinLap2 ??
          '',
        thresholdLap2:
          historyResend?.setting?.autoOptimization.thresholdLap2 ??
          settings?.autoOpThresholdLap2 ??
          '',
        thresholdPerReplyLap2:
          historyResend?.setting?.autoOptimization.thresholdPerReplyLap2 ??
          settings?.autoOpThresholdPerReplyLap2 ??
          '',
        thresholdPerBlockLap2:
          historyResend?.setting?.autoOptimization.thresholdPerBlockLap2 ??
          settings?.autoOpThresholdPerBlockLap2 ??
          '',
        thresholdPerOptoutLap2:
          historyResend?.setting?.autoOptimization.thresholdPerOptoutLap2 ??
          settings?.autoOpThresholdPerOptoutLap2 ??
          '',
        thresholdPerConvertor2:
          historyResend?.setting?.autoOptimization.thresholdPerConvertor2 ??
          settings?.autoOpThresholdPerConvertorLap2 ??
          '',

        thresholdRevenuePerMilMessageLap2:
          historyResend?.setting?.autoOptimization.thresholdRevenuePerMilMessageLap2 ??
          settings?.autoOpThresholdRevenuePerMilMessageLap2 ??
          '',
        thresholdRevenuePerMilMinuteLap2:
          historyResend?.setting?.autoOptimization.thresholdRevenuePerMilMinuteLap2 ??
          settings?.autoOpThresholdRevenuePerMilMinuteLap2 ??
          '',
        thresholdRevenuePerDeliveredCallLap2:
          historyResend?.setting?.autoOptimization.thresholdRevenuePerDeliveredCallLap2 ??
          settings?.autoOpThresholdRevenuePerDeliveredCallLap2 ??
          '',
        thresholdCallRateLap2:
          historyResend?.setting?.autoOptimization.thresholdCallRateLap2 ??
          settings?.autoOpThresholdCallRateLap2 ??
          '',
        thresholdRoiLap2:
          historyResend?.setting?.autoOptimization.thresholdRoiLap2 ??
          settings?.autoOpThresholdRoiLap2 ??
          '',
      },

      //* Target - Default phoneType = Mobile -> If change to voiceType -> clear target
      target: historyResend?.target || [],
      resendClick: false,

      //* BCC
      bccOn: false,
      bccSize: '',

      //* Campaign Offset
      campaignTitle: historyResend?.title || '',
      campaignOffset: historyResend?.campaignOffset ?? '',

      //* Multiple routes
      //* For 2 ways
      routesTwoWays: historyResend?.routesTwoWays || [CampaignModel.templateRoute],
      //* For 1 way
      routesOneWay: historyResend?.routesOneWay || [],

      contactGroups: historyResend?.contactGroups || [],
      country: historyResend?.country || '',
      totalTarget: 0,
      vertical: historyResend?.vertical || '',

      sendSpeed: isDefineValueOr(historyResend?.sendSpeed, null),

      //* TA-11166
      media: isArray(historyResend?.media) ? historyResend.media : [],
      numberOfAttachmentInMessage: historyResend?.numberOfAttachmentInMessage || 1,
      attachmentEnabled: historyResend?.attachmentEnabled || false,

      //* RVM
      campaignForwardSetting: {
        immediateForwardPhoneNumber:
          historyResend?.campaignForwardSetting?.immediateForwardPhoneNumber || '',
        viaDidGroup: isBoolean(historyResend?.campaignForwardSetting?.viaDidGroup)
          ? historyResend?.campaignForwardSetting?.viaDidGroup
          : '',
        hangup: isBoolean(historyResend?.campaignForwardSetting?.hangup)
          ? historyResend?.campaignForwardSetting?.hangup
          : true,
      },

      mediaWithConfigs: MediaModel.initialMediaWithConfig({
        media: isArray(historyResend?.mediaWithConfigs?.media)
          ? historyResend?.mediaWithConfigs?.media
          : [],
        useConfigAudio: historyResend?.mediaWithConfigs?.useConfigAudio ?? false,
        enableMediaGroup: historyResend?.mediaWithConfigs?.enableMediaGroup ?? true,
        mediaGroupId: historyResend?.mediaWithConfigs?.mediaGroupId ?? '',
        mainAudioId: historyResend?.mediaWithConfigs?.mainAudioId ?? '',
        tagsString: !isEmpty(historyResend?.mediaWithConfigs?.tagsString)
          ? CampaignModel.moveMainAudioTagToTheEnd(historyResend?.mediaWithConfigs?.tagsString)
          : DefaultMainAudioTag,
      }),

      //* Flag for resending to failed contact
      isResendToFailedContact: !!historyResend?.isResendToFailedContact,
      cpId: isDefineValueOr(historyResend?.id),

      //* TA-11505
      //* ANIS: [{ route: 221, ani: 'string' }]
      anis: isEmpty(historyResend?.anis) ? [{ ani: '' }] : historyResend?.anis || [],

      //* TA-11695
      //* Add AUTOSTOP function to campaing advanced settings
      autoStopThreshold: get(historyResend, 'setting.autoStopThreshold') || '',

      // sanitizingUnicodeEnabled: isBoolean(get(historyResend, 'setting.sanitizingUnicodeEnabled'))
      //   ? get(historyResend, 'setting.sanitizingUnicodeEnabled')
      //   : true,

      //* TA-12386 Sanitizing unicode
      sanitizing: isEmpty(historyResend)
        ? SanitizingTypeEnum.sanitizingTagUnicodeEnabled
        : get(historyResend, 'sanitizing'),

      resendFailedContactEnabled: isBoolean(
        get(historyResend, 'setting.resendFailedContactEnabled')
      )
        ? get(historyResend, 'setting.resendFailedContactEnabled')
        : false,

      populateDataSetting: removeKeyFromObj(get(historyResend, 'populateDataSetting') || {}, [
        'auto_resend_failed',
      ]),
      responderForwardPhones: get(historyResend, 'setting.responderForwardPhones') || [],
      responderAdvanceSetting: get(historyResend, 'responderOffers') || [],

      modeResponder: get(historyResend, 'modeResponder') || ModesResponderEnum.responder,
      responderTemplate: get(historyResend, 'responderTemplate') || '',
      responderId: get(historyResend, 'responderId') || '',
      responderOnFly:
        get(historyResend, 'responderOnFly') || ResponderV2Model.initialResponderOnfly(),

      //* TA-11883
      suppressionContactEnabled: get(historyResend, 'suppressionContactEnabled') ?? false,
      suppressionGroupIds: get(historyResend, 'suppressionGroupIds') || [],

      trackingVendor: get(historyResend, 'trackingVendor') || '',

      //* Optout Link
      optoutLink: OptOutModel.initialValuesOptoutLink(get(historyResend, 'optoutLink')),

      evaluatedElements: get(historyResend, 'evaluatedElements') || [],
    };
  }

  static transformResponseCampaign = (originalEl) => {
    //* Some element need calculate
    const {
      outboundIvrClickThrough,
      inboundIvrClickThrough,
      outboundIvrOptout,
      inboundIvrOptout,
      total,
      processed,
    } = originalEl;
    const delivered = originalEl?.deliveredCount || originalEl?.delivered || 0;
    const callback = originalEl?.callbackCount || originalEl?.callback || 0;
    const { maxSpeed, realSpeed } = originalEl?.campaignInfo || {};
    const realSpeedShouldBe = realSpeed < maxSpeed ? realSpeed : maxSpeed;

    const renderTimeRemaining = () => {
      //* realSpeed - msg/hours -> realSpeed / 3600 = msg/seconds
      const { hours, minutes } = calculateTimeRemainingCampaign(
        total,
        processed,
        realSpeedShouldBe / 3600
      );
      const time = `${hours ? `${hours}h` : ''} ${minutes ? `${minutes}m` : ''}`.trim();
      return time;
    };

    return {
      ...originalEl,

      roi: numberToPercentage(originalEl?.roi),
      timeRemaining: renderTimeRemaining(),
      speed: `${localeNumber(realSpeedShouldBe)} msg/h`,
      ivrClickRate: calculateIVR.ivrClickRate({
        outboundIvrClickThrough,
        inboundIvrClickThrough,
        delivered,
        callback,
      }),
      ivrOptoutRate: calculateIVR.ivrOptoutRate({
        outboundIvrOptout,
        inboundIvrOptout,
        delivered,
        callback,
      }),

      calculated: parseStatsToCalculate(originalEl),
    };
  };

  static isIvrMediaGroup = (campaign = {}) => {
    if (isEmpty(campaign)) {
      return false;
    }

    return isDefine(get(campaign, 'setting.ivrSetting.audioBuilderSettings.mediaGroupId'));
  };

  static hasMediaGroup = (campaign = {}) => {
    if (isEmpty(campaign)) {
      return false;
    }

    return (
      isDefine(get(campaign, 'mediaGroup.id')) ||
      isDefine(get(campaign, 'setting.audioBuilderSettings.mediaGroup'))
    );
  };

  static isOneWay(campaign = {}) {
    const isRoutesTwoWay =
      isArray(campaign?.routes) &&
      campaign?.routes.some((el) => isArray(el.didGroupIds) && !isEmpty(el.didGroupIds));
    return isObject(campaign) && !!campaign?.fromPhone && !isRoutesTwoWay;
  }

  static isOneWaySendMethod(sendMethod) {
    return sendMethod === sendMethodEnum.oneWay;
  }

  static isOneWayRoute(route = {}) {
    if (isEmpty(route)) {
      return false;
    }

    return route?.details?.some((el) => el.sendMethod === sendMethodEnum.oneWay);
  }

  static isTwoWaysSendMethod(sendMethod) {
    return sendMethod === sendMethodEnum.twoWays;
  }

  static isRinglessVoiceMail(msgType) {
    return [messageTypeEnum.ringlessVoicemail, messageTypeEnum.RVM].includes(msgType);
  }

  static isVoiceCampaign(msgType) {
    return [messageTypeEnum.ringlessVoicemail, messageTypeEnum.voice, messageTypeEnum.RVM].includes(
      msgType
    );
  }

  static isVoiceType(msgType) {
    return [messageTypeEnum.voice].includes(msgType);
  }

  static isRVMType(msgType) {
    return messageTypeEnum.ringlessVoicemail === msgType || messageTypeEnum.RVM === msgType;
  }

  static isMMS(msgType) {
    return [messageTypeEnum.mms].includes(msgType);
  }

  static isMMSE(msgType) {
    return [messageTypeEnum.mmse].includes(msgType);
  }

  static isSMS(msgType) {
    return [messageTypeEnum.smsSpintax, messageTypeEnum.email2sms, messageTypeEnum.RCS].includes(
      msgType
    );
  }

  static isMessageTypeSupportAttachment(msgType) {
    return allMsgTypeSupportVoice.includes(msgType);
  }

  static isAllRouteSupportVoice(routes) {
    if (isArray(routes)) {
      const detailsRoutes = routes.map((el) => el?.details || []);
      let allSupport = false;
      for (let i = 0; i < detailsRoutes.length; i++) {
        const details = detailsRoutes[i];
        if (isArray(details)) {
          for (let d = 0; d < details.length; d++) {
            const el = details[d];

            for (let msgType of allMsgTypeSupportVoice) {
              if (el.messageTypes.includes(msgType)) {
                allSupport = true;
                break;
              }
            }
          }
        }

        if (allSupport) {
          break;
        }
      }

      return allSupport;
    }

    return false;
  }

  static checkNon10DLCFound = (routes) => {
    return (routes || []).some((el) => el.is10dlc === false);
  };

  static checkIs10DLCRouteFound = (routes) => {
    return (routes || []).some((el) => el.is10dlc === true);
  };

  static isAudioLargerThanVoiceMail = (media) => {
    return (media?.duration || 0) > 60;
  };

  //* If 10DLC or TFN found -> allow apply one route
  static checkIsTFNor10DLCRoute = (routes) => {
    return (routes || []).some((el) => !!el.is10dlc || !!el.tfn);
  };

  static getVertical = (titleCampaign) => {
    if (isString(titleCampaign) && titleCampaign.toLowerCase().includes('vertical')) {
      return titleCampaign?.split('-')?.[1]?.trim()?.toUpperCase() || '';
    }

    return '';
  };

  static hasPPCOffer = (offers) => {
    return (offers || []).some((el) => !!el?.ppc);
  };

  static parseTagsStringFromResponse = (tagsString = '') => {
    if (isString(tagsString)) {
      let temp = '';
      for (let i = 0; i < tagsString.length; i++) {
        temp = temp + tagsString[i];
        if (tagsString[i] === ']') {
          temp = temp + '/**/';
        }
      }

      return temp
        .split('/**/')
        .filter((el) => !!el)
        .map((el, index) => {
          return { id: `tag-${index + 1}`, content: el, isFixed: el === MainAudioTag };
        });
    }

    return [];
  };

  static moveMainAudioTagToTheEnd = (tagStringsArr) => {
    if (!isArray(tagStringsArr) || isEmpty(tagStringsArr)) {
      return undefined;
    }

    const mainAudioElement = tagStringsArr.find(
      (el) => el.content === MainAudioTag && !!el.isFixed
    );
    const tagsStringExcludeMainAudio = tagStringsArr.filter((el) => el.content !== MainAudioTag);

    return [...tagsStringExcludeMainAudio, mainAudioElement];
  };

  //! Use for <DetailHistory /> or <CampaignMiniDashboard />
  static initialHistory(history = {}) {
    console.log('history', history);

    const initialValues = {
      ...history,

      agent: history?.setting?.agent,
      qrEnabled: history?.setting?.qrEnabled,
      attachmentEnabled: history?.setting?.attachmentEnabled,
      isEdit: false,
      idHist: history.id,
      messageType: history.messageType,
      groupId: history.groupId,
      audioId: history.audioId,
      impressionUrl: history.conversionUrl,
      scheduling: history?.sendTime
        ? momentInstance(history?.sendTime, 'YYYY-MM-DD HH:mm').toDate()
        : null,
      schedulingStopTime: history?.stopTime
        ? momentInstance(history?.stopTime, 'YYYY-MM-DD HH:mm').toDate()
        : null,
      creatives:
        history.creatives &&
        fixedValue(convertToFormSelect(history.creatives, 'title', 'creativeId')),
      offers: history.offers && fixedValue(convertToFormSelect(history.offers, 'title', 'offerId')),
      responderOffers: initialResponderOffers(history.responderOffers),
      responderTemplate: history.responderTemplate,
      timeName: history.setting?.timeName,
      target: history.setting?.target,
      targetAdjust: history.setting?.target,
      settingOptimization: history.setting,
      totalTarget: 0,

      autoOp: history.setting?.autoOptimization?.autoOp,
      pausedMin: history.setting?.autoOptimization?.pausedMin,
      testSize: history.setting?.autoOptimization?.testSize,
      threshold: history.setting?.autoOptimization?.threshold,
      thresholdPerBlock: history.setting?.autoOptimization?.thresholdPerBlock,
      thresholdPerReply: history.setting?.autoOptimization?.thresholdPerReply,
      thresholdPerOptout: history.setting?.autoOptimization?.thresholdPerOptout,
      autoOpLap2CreativeSize: history.setting?.autoOptimization?.autoOpLap2CreativeSize,

      autoOpLap2: history.setting?.autoOptimization?.autoOpLap2,
      pausedMinLap2: history.setting?.autoOptimization?.pausedMinLap2,
      testSizeLap2: history.setting?.autoOptimization?.testSizeLap2,

      thresholdLap2: history.setting?.autoOptimization?.thresholdLap2,
      thresholdPerBlockLap2: history.setting?.autoOptimization?.thresholdPerBlockLap2,
      thresholdPerOptoutLap2: history.setting?.autoOptimization?.thresholdPerOptoutLap2,
      thresholdPerReplyLap2: history.setting?.autoOptimization?.thresholdPerReplyLap2,

      thresholdPerConvertor: history.setting?.autoOptimization?.thresholdPerConvertor,
      thresholdPerConvertor2: history.setting?.autoOptimization?.thresholdPerConvertor2,

      bccOn: history?.bccSize > 0,
      bccSize: history?.bccSize || 0,

      routes: history?.routes || [],
      ani: history?.ani || '',
      fromPhone: history?.fromPhone || '',

      typeOffer: checkTypeOffer(history),
      contactGroups: history?.contactGroups || [],

      sendSpeed: isDefineValueOr(history?.sendSpeed, null),
      suppressionGroupNames: history?.suppressionGroupNames || [],
      country: history?.country || '',

      //* TA-11166
      media: isArray(history.media)
        ? history.media.map((el) => ({
            ...el,
            idByCp: el.id,
            id: el.mediaId,
            label: el.name,
            value: el.mediaId,
            isFixed: true,
          }))
        : [],
      numberOfAttachmentInMessage: history?.numberOfAttachmentInMessage || 0,

      mediaWithConfigs: MediaModel.initialMediaWithConfig({
        useConfigAudio: !!get(history, 'setting.audioBuilderSettings'),
        enableMediaGroup: !!get(history, 'setting.audioBuilderSettings.mediaGroup'),
        mainAudioId: get(history, 'setting.audioBuilderSettings.media')
          ? {
              label: get(history, 'setting.audioBuilderSettings.media')?.name,
              value: get(history, 'setting.audioBuilderSettings.media')?.id,
            }
          : undefined,
        mediaGroupId: get(history, 'setting.audioBuilderSettings.mediaGroup')
          ? {
              label: get(history, 'setting.audioBuilderSettings.mediaGroup')?.name,
              value: get(history, 'setting.audioBuilderSettings.mediaGroup')?.id,
            }
          : undefined,
        media: undefined,
        tagsString: CampaignModel.parseTagsStringFromResponse(
          get(history, 'setting.audioBuilderSettings.tagsString') || ''
        ),
      }),

      anis: history?.anis,
      routeAnis: history?.setting?.routeAnis,
      responderForwardPhones: get(history, 'setting.responderForwardPhones') || [],
    };

    return initialValues;
  }

  static filtersChart = (values) => {
    return {
      cpId: values?.cpId,
      dateRanges: {
        from: values?.to || setTimeOfDateToDefault(dateTimeDefault().before3Days()),
        to: values?.from || setTimeOfDateToDefault(dateTimeDefault().today(), true),
      },
    };
  };

  static parseRequestToSendServlet(values = {}, routesInfo = []) {
    const isOneway = CampaignModel.isOneWaySendMethod(values?.sendMethod);

    const enableSwitchQRAndAttachment = checkSwitchQRAndAttachment(
      routesInfo,
      values?.routesOneWay,
      values?.routesTwoWays,
      values?.country,
      values?.sendMethod,
      values?.messageType
    );

    const body = {
      ...parseDTMFTimeoutAndAMD(values),
      ...parseAutoOptimization(values),
      ...parseOffers(values),
      ...parseCreatives(values),
      ...parseRoutes(values),
      ...parsePopulateGroup(values),

      ...parseResponderOffer(values),
      ...parseResponderForwardPhones(values),
      ...parseSuppressionContactGroup(values),
      ...parseResponderAndTemplate(values),
      ...parseResponderOnfly(values),
      ...parseTrackingVendor(values),
      ...parseMedia(values),
      ...parseOptoutLink(values),
      ...parseSanitizingUnicode(values),
      ...parseEvaluatedElements(values),
      ...parseDebugMode(values),
      ...parseAIAgent(values),

      certedVertical: values?.certedVertical,
      resendFailedContactEnabled: values?.resendFailedContactEnabled,
      sendMethod: values.sendMethod,
      contactGroups: isArray(values?.contactGroups)
        ? values?.contactGroups.map((el) => ({ groupId: el.id, status: true }))
        : [],
      scheduling:
        values?.activeScheduling && values?.scheduling
          ? moment(values?.scheduling).format('YYYY-MM-DD HH:mm')
          : '',
      schedulingStopTime:
        values?.activeScheduling && values?.schedulingStopTime
          ? moment(values?.schedulingStopTime).format('YYYY-MM-DD HH:mm')
          : '',
      timeName: values?.activeScheduling ? values?.timeName : '',
      sendByContactTimezone: !!(values?.activeScheduling && values?.sendByContactTimezone),
      messageType: values?.messageType,
      fromPhone: values?.fromPhone,
      impressionUrl: values?.impressionUrl,
      audioId: values?.audioId,

      target: parseTargetToRequest(values?.target || [], {
        filterType: FilterTargetTypeEnum.INCLUDE,
      }),
      excludeTarget: parseTargetToRequest(values?.target || [], {
        filterType: FilterTargetTypeEnum.EXCLUDE,
      }),

      //* TA-2708
      campaignTitle: isString(values?.campaignTitle) ? values?.campaignTitle.trim() : '',

      //* BCC
      bccOn: values?.messageType === messageTypeEnum.mms ? values?.bccOn : false,
      bccSize:
        values?.messageType === messageTypeEnum.mms && values?.bccOn ? Number(values?.bccSize) : 0,

      //* Campaign offset
      campaignOffset: values?.campaignOffset ? parseInt(values?.campaignOffset, 10) : '',
      vertical: values?.vertical,

      //* TA-10967
      sendSpeed: isDefineValueOr(values?.sendSpeed, null),

      //* TA-11113
      qrEnabled:
        values?.offerOption !== stateOffer.NO_OFFER && enableSwitchQRAndAttachment
          ? values?.qrEnabled
          : false,
      attachmentEnabled: enableSwitchQRAndAttachment ? values?.attachmentEnabled : false,

      //* TA-11695
      autoStopThreshold: isNumeric(values?.autoStopThreshold)
        ? Number(values?.autoStopThreshold)
        : '',

      //* ANIs
      anis: parseANIS(isOneway ? values.anis : undefined)?.anis || undefined,
    };

    if (
      !CampaignModel.isMessageTypeSupportAttachment(values?.messageType) ||
      (!CampaignModel.isVoiceCampaign(values?.messageType) && !body.attachmentEnabled)
    ) {
      body.media = [];
      body.numberOfAttachmentInMessage = 0;
    }

    if (CampaignModel.isVoiceCampaign(values?.messageType)) {
      body.numberOfAttachmentInMessage = 1;
    }

    if (!values?.mediaWithConfigs?.useConfigAudio) {
      body.audioBuilderSettings = null;
    }

    return body;
  }

  static parseRequestToUpdateHistory(values = {}) {
    if (isObject(values)) {
      const {
        groupId,
        messageType,
        audioId,
        timeName,
        responderTemplate,
        impressionUrl,
        targetAdjust,
        bccOn,
        bccSize,
        routeId,
        routes,
        contactGroups,
        scheduling,
        schedulingStopTime,
        sendSpeed,

        //* TA-11113
        qrEnabled,
        attachmentEnabled,
        suppressionGroupNames,
      } = values;
      const isOneWay = CampaignModel.isOneWaySendMethod(values?.sendMethod);
      let { offers, domainGroup } = values;

      const isSupportQR =
        (isArray(offers) && !isEmpty(offers)) || (isArray(domainGroup) && !isEmpty(domainGroup));

      const body = {
        ...parseOffers(values),
        ...parseCreatives(values),
        ...parseResponderForwardPhones(values),

        groupId,
        messageType,
        audioId,
        responderTemplate,
        impressionUrl,
        scheduling: scheduling ? momentInstance(scheduling).format('YYYY-MM-DD HH:mm') : undefined,
        schedulingStopTime: schedulingStopTime
          ? momentInstance(schedulingStopTime).format('YYYY-MM-DD HH:mm')
          : undefined,
        target: targetAdjust,
        timeName,
        bccOn: messageType === messageTypeEnum.mms ? bccOn : false,
        bccSize: messageType === messageTypeEnum.mms && bccOn ? Number(bccSize) : 0,
        routeId,
        routes,
        contactGroups: isArray(contactGroups)
          ? contactGroups.map((el) => ({ id: el.id, status: el.status }))
          : [],
        sendSpeed: isDefine(sendSpeed) ? Number(sendSpeed) : null,

        //* TA-11113
        qrEnabled: isSupportQR ? qrEnabled : false,
        attachmentEnabled: attachmentEnabled,
        suppressionGroupNames: isArray(suppressionGroupNames)
          ? suppressionGroupNames.map((el) => el.label)
          : [],

        //* TA-11166
        media: isArray(values?.media)
          ? values?.media?.map((el) => ({
              id: el?.mediaId || el.id,
              name: el?.name,
            }))
          : [],
        campaignOffset: values?.campaignOffset,
        autoStopThreshold: values?.setting?.autoStopThreshold,
      };

      body.anis = isOneWay ? parseANIS(values?.anis).anis : [];
      return body;
    }

    return {};
  }

  static parseResponseHistoryPhone(historyPhone) {
    if (isArray(historyPhone)) {
      return historyPhone.map((history) => {
        const { routes = [], messageType } = history || {};
        const { usedPhones, poolSize } = history?.campaignInfo || {};
        const el = CampaignModel.transformResponseCampaign(history);

        const phonesUsed = (usedPhones || []).length;

        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));
        const isVoiceCampaign = CampaignModel.isVoiceCampaign(messageType);

        const result = {
          ...el,
          title: el?.title || '',
          contactGroup: el?.groupName || '',

          progress: (Number(el.processed) / Number(el.total)) * 100,
          didInUsed: `${phonesUsed}/${poolSize}`,

          //* Route
          nameInRoute: routes[0]?.routeName || '',
          didGroupOrANI: routes[0]?.didGroupName || routes[0]?.ani,

          //* Statistic
          sent: localeNumber(el?.sentSoFar) || 0,
          delivered: `${calculator.deliveredPercentage} (${localeNumber(el?.deliveredCount)})`,
          deliveredPercentage: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage} (${localeNumber(el?.noOfFail)})`,
          blocked: `${calculator.blockPercentage} (${localeNumber(el?.blockedCount)})`,
          replied: `${calculator.repliedPercentage} (${localeNumber(el?.replied)})`,
          optout: `${calculator.optoutPercentage} (${localeNumber(el?.optout)})`,
          total: localeNumber(el?.total) || 0,
          clicked: `${calculator.clickedPercentage} (${localeNumber(el?.clickCounter)})`,
          attemptFailed: `${localeNumber(el?.attemptFailed)}`,
          convertor: `${calculator.convertorPercentage} (${localeNumber(el?.convertorCount)})`,
          callbackCount: `${calculator.callbackPercentage} (${localeNumber(el?.callbackCount)})`,
          listenCounter: `${calculator.listenCounterPercentage} (${localeNumber(
            el?.listenCounter
          )})`,

          rawStats: {
            ...collectRawStats(el),
            profit: Math.round((el?.revenue || 0) - (el?.cost || 0)),
          },

          totalDid: localeNumber(el?.totalDid),
          remainContact: localeNumber(el?.remainContact),

          //* Cost
          totalCost: costCalculator.total({ cost: el?.cost }),
          perClick: costCalculator.costPerClicked({
            cost: el?.cost,
            clicked: el.clickCounter,
          }),
          perMessage: costCalculator.costPerMessage({
            cost: el?.cost,
            // cost per message if isVoiceMail (voice/rvm) -> cost / minute else -> cost / sent
            sent: isVoiceCampaign ? el?.callDurationInMinute : el.sentSoFar,
          }),
          revenueCell: costCalculator.revenue(el?.revenue || 0),
          revenuePerMilCell: costCalculator.revenue(el?.revenuePerMil || 0),

          //* Routes
          routes: (el?.routes || []).map((r) => ({
            ...r,
            ani: el?.fromPhone,
            isRouteOneWay: !!el?.fromPhone,
          })),
          profit: costCalculator.profit({ revenue: el?.revenue, cost: el?.cost }),

          //* Attachment
          qrEnabled: el?.qrEnabled || false,
          attachmentEnabled: el?.attachmentEnabled || false,

          //* Call duration
          callDuration: convertDurationStats(
            (el?.callDurationInMinute || 0) / (el?.deliveredCount || 1)
          ),
        };

        return result;
      });
    }

    return [];
  }

  static parseRouteStats(routes = []) {
    if (isArray(routes)) {
      const tempRoutes = cloneDeep(routes);
      tempRoutes.sort((prev, cur) => {
        return prev.id - cur.id;
      });

      return tempRoutes.map((item) => {
        const el = CampaignModel.transformResponseCampaign(item);
        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));

        const route = {
          ...el,

          rawStats: collectRawStats(el),

          sent: el?.sent || 0,
          delivered: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage}`,
          blocked: `${calculator.blockPercentage} `,
          replied: `${calculator.repliedPercentage} `,
          optout: `${calculator.optoutPercentage} `,
          total: el?.total || 0,
          clicked: `${calculator.clickedPercentage}`,
          attemptFailed: localeNumber(el?.attemptFailed || 0),
          convertor: `${calculator.convertorPercentage}`,
          revenue: costCalculator.revenue(el?.revenue),
          revenuePerMil: costCalculator.revenue(el?.revenuePerMil),
          callback: `${calculator.callbackPercentage}`,
          listen: calculator.listenCounterPercentage,

          //* Call duration
          callDuration: convertDurationStats(
            (el?.callDurationInMinute || 0) / (el?.delivered || 1)
          ),
        };

        return { ...route, subRows: CampaignModel.parseDIDGroupsStats(route) };
      });
    }

    return [];
  }

  static parseDIDGroupsStats(route) {
    if (isPlainObject(route) && isArray(get(route, 'campaignDidGroups'))) {
      const tempDIDGroups = cloneDeep(get(route, 'campaignDidGroups'));
      tempDIDGroups.sort((prev, cur) => {
        return prev.id - cur.id;
      });

      return tempDIDGroups.map((item) => {
        const el = CampaignModel.transformResponseCampaign(item);
        //* Calculate base on total of route
        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));

        return {
          ...el,

          rawStats: collectRawStats(el),

          sent: el?.sent || 0,
          delivered: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage}`,
          blocked: `${calculator.blockPercentage} `,
          replied: `${calculator.repliedPercentage} `,
          optout: `${calculator.optoutPercentage} `,
          total: el?.total || 0,
          clicked: `${calculator.clickedPercentage}`,
          attemptFailed: localeNumber(el?.attemptFailed || 0),
          convertor: `${calculator.convertorPercentage}`,
          revenue: costCalculator.revenue(el?.revenue),
          revenuePerMil: costCalculator.revenue(el?.revenuePerMil),
          callback: `${calculator.callbackPercentage}`,
          listen: calculator.listenCounterPercentage,

          //* Call duration
          callDuration: convertDurationStats(
            (el?.callDurationInMinute || 0) / (el?.delivered || 1)
          ),
        };
      });
    }

    return [];
  }

  static parseCreativesStats(data = []) {
    if (isArray(data)) {
      return data.map((el) => {
        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));

        return {
          ...el,
          ...CampaignModel.transformResponseCampaign(el),

          name: el?.title,
          rawStats: collectRawStats(el),

          sent: el?.sent || 0,
          delivered: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage}`,
          blocked: `${calculator.blockPercentage} `,
          replied: `${calculator.repliedPercentage} `,
          optout: `${calculator.optoutPercentage} `,
          total: el?.total || 0,
          clicked: `${calculator.clickedPercentage}`,
          attemptFailed: localeNumber(el?.attemptFailed || 0),
          revenue: costCalculator.revenue(el?.revenue || 0),
          revenuePerMil: costCalculator.revenue(el?.revenuePerMil || 0),
          callback: `${calculator.callbackPercentage}`,
          listen: calculator.listenCounterPercentage,

          //* Call duration
          callDuration: convertDurationStats(
            (el?.callDurationInMinute || 0) / (el?.delivered || 1)
          ),
        };
      });
    }

    return [];
  }

  static parseOfferStats(data = []) {
    if (isArray(data)) {
      return data.map((el) => {
        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));

        return {
          ...el,

          rawStats: collectRawStats(el),

          sent: el?.sent || 0,
          delivered: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage}`,
          blocked: `${calculator.blockPercentage} `,
          replied: `${calculator.repliedPercentage} `,
          optout: `${calculator.optoutPercentage} `,
          total: el?.total || 0,
          clicked: `${calculator.clickedPercentage}`,
          attemptFailed: localeNumber(el?.attemptFailed || 0),
          revenue: costCalculator.revenue(el?.revenue || 0),
          revenuePerMil: costCalculator.revenue(el?.revenuePerMil || 0),
          callback: `${calculator.callbackPercentage}`,
          listen: calculator.listenCounterPercentage,
        };
      });
    }

    return [];
  }

  static parseOfferStatsWithSubRowsAndSortBy(data = [], sortBy) {
    if (isArray(data)) {
      return data.map((el) => {
        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));

        const offer = {
          ...CampaignModel.transformResponseCampaign(el),
          name: el?.title,
          rawStats: collectRawStats(el),

          sent: el?.sent || 0,
          delivered: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage}`,
          blocked: `${calculator.blockPercentage} `,
          replied: `${calculator.repliedPercentage} `,
          optout: `${calculator.optoutPercentage} `,
          total: el?.total || 0,
          clicked: `${calculator.clickedPercentage}`,
          attemptFailed: localeNumber(el?.attemptFailed || 0),
          revenue: costCalculator.revenue(el?.revenue || 0),
          revenuePerMil: costCalculator.revenue(el?.revenuePerMil || 0),
          callback: `${calculator.callbackPercentage}`,
          listen: calculator.listenCounterPercentage,
        };

        const domainGroupsConvertedStats = CampaignModel.parseDomainGroupInOffers(
          offer?.domainGroups || []
        );

        const sortedDataDomainGroups = CampaignModel.sortDataCreativeOfferDomain(
          domainGroupsConvertedStats,
          sortBy
        );

        return { ...offer, subRows: sortedDataDomainGroups };
      });
    }

    return [];
  }

  static parseContactGroups(data = []) {
    if (isArray(data)) {
      return data.map((elContact) => {
        const el = CampaignModel.transformResponseCampaign(elContact);
        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));

        return {
          ...el,

          rawStats: collectRawStats(el),

          sent: el?.sent || 0,
          delivered: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage}`,
          blocked: `${calculator.blockPercentage} `,
          replied: `${calculator.repliedPercentage} `,
          optout: `${calculator.optoutPercentage} `,
          total: el?.total || 0,
          clicked: `${calculator.clickedPercentage}`,
          attemptFailed: localeNumber(el?.attemptFailed || 0),
          revenue: costCalculator.revenue(el?.revenue || 0),
          revenuePerMil: costCalculator.revenue(el?.revenuePerMil || 0),
          convertor: `${calculator.convertorPercentage}`,
          callback: `${calculator.callbackPercentage}`,
          listen: calculator.listenCounterPercentage,

          acd: calculator.acd,

          //* Call duration
          callDuration: convertDurationStats(
            (el?.callDurationInMinute || 0) / (el?.delivered || 1)
          ),
        };
      });
    }

    return [];
  }

  static parseMediaStats(data = []) {
    if (isArray(data)) {
      return data.map((el) => {
        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));

        return {
          ...el,
          ...CampaignModel.transformResponseCampaign(el),
          rawStats: collectRawStats(el),

          sent: el?.sent || 0,
          delivered: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage}`,
          blocked: `${calculator.blockPercentage} `,
          replied: `${calculator.repliedPercentage} `,
          optout: `${calculator.optoutPercentage} `,
          total: el?.total || 0,
          clicked: `${calculator.clickedPercentage}`,
          attemptFailed: localeNumber(el?.attemptFailed || 0),
          revenue: costCalculator.revenue(el?.revenue || 0),
          revenuePerMil: costCalculator.revenue(el?.revenuePerMil || 0),
          convertor: `${calculator.convertorPercentage}`,
          callback: `${calculator.callbackPercentage}`,
          listen: calculator.listenCounterPercentage,
        };
      });
    }

    return [];
  }

  static parseDomainGroupInOffers(domainGroups = []) {
    if (!isArray(domainGroups)) {
      return [];
    }

    return domainGroups.map((domainGroup) => {
      const calculator = statsCalculator.percentage(parseStatsToCalculate(domainGroup));

      return {
        ...CampaignModel.transformResponseCampaign(domainGroup),
        ...domainGroup,
        rawStats: collectRawStats(domainGroup),
        delivered: calculator.deliveredPercentage,
        failed: calculator.failedPercentage,
        blocked: calculator.blockPercentage,
        replied: calculator.repliedPercentage,
        clicked: calculator.clickedPercentage,
        optout: calculator.optoutPercentage,
        callback: calculator.callbackPercentage,
        listen: calculator.listenCounterPercentage,
      };
    });
  }

  static parseANIStats(data = []) {
    if (isArray(data)) {
      return data.map((el) => {
        const calculator = statsCalculator.percentage(parseStatsToCalculate(el));

        return {
          ...el,

          rawStats: collectRawStats(el),

          sent: el?.sent || 0,
          delivered: `${calculator.deliveredPercentage}`,
          failed: `${calculator.failedPercentage}`,
          blocked: `${calculator.blockPercentage} `,
          replied: `${calculator.repliedPercentage} `,
          optout: `${calculator.optoutPercentage} `,
          total: el?.total || 0,
          clicked: `${calculator.clickedPercentage}`,
          attemptFailed: localeNumber(el?.attemptFailed || 0),
          revenue: costCalculator.revenue(el?.revenue || 0),
          revenuePerMil: costCalculator.revenue(el?.revenuePerMil || 0),
          convertor: `${calculator.convertorPercentage}`,
          callback: `${calculator.callbackPercentage}`,
          listen: calculator.listenCounterPercentage,
        };
      });
    }
  }

  //! Request
  static checkIsOnlyRunningCampaignSelected(statuses) {
    return statuses.length === 1 && statuses?.map((el) => el.value).includes(stateCampaign.RUNNING);
  }

  static checkIsRunningCampaignSelected(statuses) {
    return statuses?.map((el) => el.value).includes(stateCampaign.RUNNING);
  }

  //! Request
  static initialFilterSearchHis = ({ original = false } = {}) => {
    const result = {
      statuses: [optionFilterHistory[0]],
      offset: DEFAULT_OFFSET_FOR_MONITORING,
      text: '',
      groupName: '',
      didGroupId: '',
      routeId: '',

      groupNames: [],
      didGroupIds: [],
      routeIds: [],
      countries: [],

      sortField: '',
      sortDirection: '',
      limit: 20,

      dateRanges: {
        from: undefined,
        to: undefined,
      },
      dateRangesLastSend: {
        from: undefined,
        to: undefined,
      },

      sentFrom: '',
      sentTo: '',
      deliveredFrom: '',
      deliveredTo: '',
      clickedFrom: '',
      clickedTo: '',
      repliedFrom: '',
      repliedTo: '',
      convertorFrom: '',
      convertorTo: '',
      optoutFrom: '',
      optoutTo: '',
      failedFrom: '',
      failedTo: '',
      blockedFrom: '',
      blockedTo: '',
      attemptFailedFrom: '',
      attemptFailedTo: '',
      revenueFrom: '',
      revenueTo: '',
      revenuePerMilFrom: '',
      revenuePerMilTo: '',

      country: '',
      messageType: '',
    };

    if (!original) {
      const queryParams = getQueryStringFromURL();
      const text = queryParams?.[CAMPAIGN_TITLE];

      if (text) {
        result.text = text;
        result.statuses = optionFilterHistory;
      }
    }

    return result;
  };

  static parseFilterSearchHis(values = {}) {
    const correctValues = cloneDeep(values);
    const { dateRanges, dateRangesLastSend } = correctValues;

    const { from: endDateFrom, to: endDateTo } = timezoneHelpers.convertDateRangeByTimezone({
      from: dateRanges?.from,
      to: dateRanges?.to,
      format: DEFAULT_DATETIME_MONITORING_FORMAT,
    });

    const { from: lastSendDateFrom, to: lastSendDateTo } =
      timezoneHelpers.convertDateRangeByTimezone({
        from: dateRangesLastSend?.from,
        to: dateRangesLastSend?.to,
        format: DEFAULT_DATETIME_MONITORING_FORMAT,
      });

    return {
      country: correctValues?.country,
      statuses: correctValues?.statuses?.map((status) => status.value) || [
        optionFilterHistory[0].value,
      ],
      offset: correctValues?.offset || DEFAULT_OFFSET_FOR_MONITORING,
      text: correctValues?.text || '',
      groupName: correctValues?.groupName?.label,
      didGroupId: correctValues?.didGroupId?.id || '',
      routeId: correctValues?.routeId?.value || '',
      sortField: correctValues?.sortField || '',
      sortDirection: correctValues?.sortDirection || '',
      limit: 20,

      groupNames: correctValues?.groupNames?.map((el) => el.label) || [],
      didGroupIds: correctValues?.didGroupIds?.map((el) => el.value) || [],
      routeIds: correctValues?.routeIds?.map((el) => el.value) || [],
      countries: correctValues?.countries?.map((el) => el.value) || [],

      sentFrom: correctValues?.sentFrom || null,
      sentTo: correctValues?.sentTo || null,
      deliveredFrom: correctValues?.deliveredFrom || null,
      deliveredTo: correctValues?.deliveredTo || null,
      clickedFrom: correctValues?.clickedFrom || null,
      clickedTo: correctValues?.clickedTo || null,
      repliedFrom: correctValues?.repliedFrom || null,
      repliedTo: correctValues?.repliedTo || null,
      convertorFrom: correctValues?.convertorFrom || null,
      convertorTo: correctValues?.convertorTo || null,
      optoutFrom: correctValues?.optoutFrom || null,
      optoutTo: correctValues?.optoutTo || null,
      failedFrom: correctValues?.failedFrom || null,
      failedTo: correctValues?.failedTo || null,
      blockedFrom: correctValues?.blockedFrom || null,
      blockedTo: correctValues?.blockedTo || null,
      attemptFailedFrom: correctValues?.attemptFailedFrom || null,
      attemptFailedTo: correctValues?.attemptFailedTo || null,
      revenueFrom: correctValues?.revenueFrom || null,
      revenueTo: correctValues?.revenueTo || null,
      revenuePerMilFrom: correctValues?.revenuePerMilFrom || null,
      revenuePerMilTo: correctValues?.revenuePerMilTo || null,

      endDateFrom,
      endDateTo,

      lastSendDateFrom,
      lastSendDateTo,
      messageType: correctValues?.messageType || undefined,
    };
  }

  static getMoreFiltersMonitoring(prevFilters) {
    return cloneObjectByKeys(
      [
        'sentFrom',
        'sentTo',
        'deliveredFrom',
        'deliveredTo',
        'clickedFrom',
        'clickedTo',
        'repliedFrom',
        'repliedTo',
        'convertorFrom',
        'convertorTo',
        'optoutFrom',
        'optoutTo',
        'failedFrom',
        'failedTo',
        'blockedFrom',
        'blockedTo',
        'attemptFailedFrom',
        'attemptFailedTo',
        'revenueFrom',
        'revenueTo',
        'revenuePerMilFrom',
        'revenuePerMilTo',
      ],
      prevFilters
    );
  }

  static eachTotalOfContact = (contactId, total) => {
    return {
      contactId,
      total,
    };
  };

  static calculateTotalContact = (totalOfContactGroups) => {
    const totalArr = Object.values(totalOfContactGroups);

    if (totalArr.length > 0) {
      return totalArr.reduce((number, el) => {
        return number + el;
      }, 0);
    }

    return 0;
  };

  static filterTargetInvalid(targets = []) {
    return targets.filter((el) => !!el.contactField).filter((el) => !!el.valueContactField);
  }

  static sortDataCreativeOfferDomain(data = [], sortBy = []) {
    const { id: sortField, desc } = sortBy?.[0] || {};
    const tempData = isArray(data) ? cloneDeep(data) : [];

    if (sortField) {
      if (desc) {
        const sortedArr = sortByLodash(tempData, [
          (el) => {
            return convertValueStringToNumberToCompare(get(el, sortField));
          },
        ]);
        sortedArr.reverse();
        return sortedArr;
      }

      return sortByLodash(tempData, [
        (el) => {
          return convertValueStringToNumberToCompare(get(el, sortField));
        },
      ]);
    }

    return tempData;
  }

  //* isRaw is rawStats not be converted / formatted
  static sortingByField(field, { isRaw = false, customSortingFunc } = {}) {
    if (customSortingFunc) {
      return (cpA, cpB) => customSortingFunc(cpA, cpB);
    }

    return (cpA, cpB) => {
      const Astat = isRaw ? get(cpA, `original.rawStats.${field}`) : get(cpA, `original.${field}`);
      const Bstat = isRaw ? get(cpB, `original.rawStats.${field}`) : get(cpB, `original.${field}`);

      if (isString(Astat) && Astat.includes('$')) {
        const AstatFormatted = Astat.replace('$', '').replace(',', '');
        const BstatFormatted = Bstat.replace('$', '').replace(',', '');
        return parseFloat(AstatFormatted) - parseFloat(BstatFormatted);
      }

      if (isString(Astat) && Astat.includes('%')) {
        const AstatFormatted = Astat.replace('%', '').replace(',', '');
        const BstatFormatted = Bstat.replace('%', '').replace(',', '');
        return parseFloat(AstatFormatted) - parseFloat(BstatFormatted);
      }

      if (isString(Astat)) {
        return parseFloat(Astat) - parseFloat(Bstat);
      }

      return Astat - Bstat;
    };
  }
}

export default CampaignModel;
